"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
var _deepMap = require("../../util/deepMap");
var _deepRename = require("../../util/deepRename");
var _mediaBreakpointMixin = require("../mediaBreakpointMixin");
var UNIT_ORPHANS = ['flexGrow', 'fontWeight', 'gridColumn', 'gridRow', 'transitionTiming', 'opacity', 'order', 'zIndex'];
var getTransformedToken = function getTransformedToken(_ref) {
  var styleVal = _ref.styleVal,
    props = _ref.props,
    attr = _ref.attr;
  var transformToken = function transformToken(val) {
    return val.split(' ').map(function (prop) {
      if (!prop.includes('$')) {
        return prop;
      }
      return prop.split(',').map(function (p) {
        if (!p.includes('$')) {
          return p;
        }
        var variant = p.replace(/\\s|/g, '').replace(/^\$/g, '').replace(/(\$.*?)/g, '.').replace(/[()]/g, '')
        // Handles tokens within `calc()`, ie `calc($spacing.sm - 10px)`
        .replace(/^calc\./g, '');
        variant = (0, _styledToken.default)(variant)(props);
        variant = typeof variant === 'number' && !UNIT_ORPHANS.includes(attr) ? variant + "px" : variant;

        // add back any parentheses
        if (p.endsWith(')')) {
          variant = variant + ")";
        }
        if (p.startsWith('(')) {
          variant = "(" + variant;
        }
        if (p.startsWith('calc(')) {
          variant = "calc(" + variant;
        }
        return variant;
      }).join(',');
    }).join(' ');
  };
  if (typeof styleVal === 'string') {
    return transformToken(styleVal);
  }
  return styleVal;
};

/** @class BoxMixin */
/** @method */
var BoxMixin = function BoxMixin(props) {
  if (!props.sx) {
    return {};
  }
  var sx = props.sx;
  var getMQText = function getMQText(mq) {
    if (!mq.includes('$')) {
      return mq;
    }
    var breakpoint = mq.match(/(\$)\w+/g)[0].replace(/^\$/g, '');
    return "@media " + (0, _mediaBreakpointMixin.mediaBreakpointMixin)(breakpoint)(props);
  };
  var styles = (0, _deepRename.deepRename)(sx, getMQText);
  return (0, _deepMap.deepMap)(styles, function (val, key) {
    if (Array.isArray(val)) {
      return val.map(function (v) {
        return typeof v !== 'number' ? getTransformedToken({
          styleVal: v,
          attr: key,
          props: props
        }) : v;
      }).map(function (v) {
        return "\"" + v + "\"";
      }).join(' ');
    }
    return typeof val !== 'number' ? getTransformedToken({
      styleVal: val,
      attr: key,
      props: props
    }) : val;
  });
};
exports.BoxMixin = BoxMixin;